import React, { useContext, useState, useEffect } from 'react';
import {
    Accordion, AccordionHeader, AccordionHeaderProps, AccordionItem, AccordionPanel, AccordionToggleEventHandler,
} from "@fluentui/react-components";
import { Suits1, SuitSymbols, SuitColors, DealSeats, CardSeatsStringMap } from './BridgeTypes';
import { GameSettingsContext } from './BridgeEngineSettings';
import { PlayStateContext } from './BridgeEnginePlay';
import BridgeMarkdown from './BridgeMarkdown';
import './Hints.css';

interface HintsProps {
}

const Hints: React.FC<HintsProps> = () => {
    const gameSettingsContext = useContext(GameSettingsContext)!;
    const { gameSettings } = gameSettingsContext;

    const playState = useContext(PlayStateContext)!;
    const [leadShown, setLeadShown] = useState<boolean>(playState.turnState.leadShown);
    const [hintsShown, setHintsShown] = useState<number>(playState.turnState.hintsShown);
    const [priorHintsShown, setPriorHintsShown] = useState<number>(0);
    const [openItems, setOpenItems] = React.useState(['lead']);

    const handleToggle: AccordionToggleEventHandler<string> = (event, data) => {
        setOpenItems(data.openItems);
    };

    useEffect(() => {
        setLeadShown(playState.turnState.leadShown);
        setHintsShown(playState.turnState.hintsShown);
        if (playState.turnState.hintsShown === 0) {
            setOpenItems(["lead"]);
            setPriorHintsShown(0);
        }
    }, [playState.turnState.leadShown, playState.turnState.hintsShown]);

    if (!leadShown && hintsShown === 0) {
        return (
            <></>
        )
    }

    if (playState.boardState.lead.length === 0 && (playState.boardState.hints === undefined || playState.boardState.hints.length === 0)) {
        // TODO: could beep here.
        return (
            <></>
        )
    }

    // is there any lead? if not, bump the hints shown count to the first one.
    if (playState.turnState.leadShown && playState.boardState.lead.length === 0 && hintsShown === 0) {
        playState.showHint();
    }

    if (hintsShown >= playState.boardState.hints.length) {
        // TODO: beep since there are no more hints.
    }

    const processLeadText = (text: string): string => {
        if (text.length === 0) {
            text = "No lead provided. Hint follows, if any.";
        } else
        if (text.length === 2) {
            // do this first so we can replace T with 10 and not shift this.
            if (Suits1.includes(text[1].toLowerCase())) {
                const suitIndex = Suits1.indexOf(text[1].toLowerCase());
                text = text[0] + SuitSymbols[suitIndex];
            }
            // with the suit fixed, now fix the rank if T.
            if (text[0] === 'T' && !gameSettings.tenAsT) {
                text = text.replace('T', '10');
            }
            const leadSeat: DealSeats | null = playState.getLeadSeat();
            if (!leadSeat) {
                text = `Auction error lead: ${text}`;
            } else {
                text = `${CardSeatsStringMap[leadSeat]} leads: ${text}`;
            }
        }
        return text;
    }
    
    const renderLead = () => {
        // calculate who leads from auction.
        let markdownText = playState.boardState.lead;
        return (
            <AccordionItem value="lead">
                <AccordionHeader><span>Lead</span></AccordionHeader>
                <AccordionPanel className='accordion-panel'>
                    <BridgeMarkdown>
                        {processLeadText(markdownText)}
                    </BridgeMarkdown>
                </AccordionPanel>
            </AccordionItem>
        );
    }

    const renderHints = () => {
        if (hintsShown === 0) {
            return (
                <></>
            );
        }
        if (playState.boardState.hints === undefined || playState.boardState.hints.length === 0) {
            return (
            <></>
            );
        }
        return playState.boardState.hints.slice(0, hintsShown).map((hint, index) => {
            let markdownText = hint.join('\n');
            return (
                <AccordionItem key={index} value={index.toString()}>
                    <AccordionHeader><span>Hint {index + 1}</span></AccordionHeader>
                    <AccordionPanel className='accordion-panel'>
                        <BridgeMarkdown>
                            {markdownText}
                        </BridgeMarkdown>
                    </AccordionPanel>
                </AccordionItem>
            );
        });
    }

    if (hintsShown > priorHintsShown) {
        const newOpenItems = [...openItems];
        for (let i = priorHintsShown; i < hintsShown; i++) {
            newOpenItems.push((i).toString());
        }
        setPriorHintsShown(hintsShown);
        setOpenItems(newOpenItems);
    }

    return (
        <div className="div-hints">
            <Accordion
                openItems={openItems}
                onToggle={handleToggle}
                multiple
                collapsible
            >
                {renderLead()}
                {renderHints()}
            </Accordion>
        </div>
    );
};

export default Hints;